import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {ISimplePresentation, SimplePresentationRunner} from "../SimplePresentationRunner";
import {CollapseRunner} from "../presentationRunner/CollapseRunner";
import {XSplitRunner} from "../presentationRunner/XSplitRunner";
import {XNudgeRunner} from "../presentationRunner/XNudgeRunner";
import {FeatureIntroRunner} from "../presentationRunner/FeatureIntroRunner";
import {FeatureOutroRunner} from "../presentationRunner/FeatureOutroRunner";
import {XBombRunner} from "../presentationRunner/XBombRunner";
import {GrenadeRunner} from "../presentationRunner/GrenadeRunner";
import {BulldozerExplosionRunner} from "../presentationRunner/BulldozerExplosionRunner";
import {BazookaRunner} from "../presentationRunner/BazookaRunner";
import {AirstrikeRunner} from "../presentationRunner/AirstrikeRunner";
import {GEBombRunner} from "../presentationRunner/GEBombRunner";
import {Game} from "../Game";
import {KillCountRunner} from "../presentationRunner/KillCountRunner";
import {SuicideBombRunner} from "../presentationRunner/SuicideBombRunner";
import {BigWinRunner} from "../presentationRunner/BigWinRunner";
import {MayhemSpinsRunner} from "../presentationRunner/MayhemSpinsRunner";
import {C1Runner} from "../presentationRunner/C1Runner";
import {C2Runner} from "../presentationRunner/C2Runner";
import {C3Runner} from "../presentationRunner/C3Runner";
import {C4Runner} from "../presentationRunner/C4Runner";
import {NormalWinRunner} from "../presentationRunner/NormalWinRunner";
import {AllHighlightRunner} from "../presentationRunner/AllHighlightRunner";
import {BulldozerDriveRunner} from "../presentationRunner/BulldozerDriveRunner";
import {MXRunner} from "../presentationRunner/MXRunner";
import {MaxWinRunner} from "../presentationRunner/MaxWinRunner";
import {TankBoostersRunner} from "../presentationRunner/TankBoostersRunner";
import {Symbol, SymbolStates} from "../reels/Symbol";

export class WinPresentation implements FlowStatePresentation {

    private readonly _presentations: ISimplePresentation[];
    private _flowStateController: FlowStateController;

    constructor() {
        this._presentations = [
            new TankBoostersRunner(),
            new XSplitRunner(),
            new XNudgeRunner(),
            new BulldozerDriveRunner(),
            new AllHighlightRunner(),
            new C1Runner(),
            new C2Runner(),
            new C3Runner(),
            new C4Runner(),
            new BulldozerExplosionRunner(),
            new GrenadeRunner(),
            new BazookaRunner(),
            new XBombRunner(),
            new GEBombRunner(),
            new AirstrikeRunner(),
            new SuicideBombRunner(),
            new KillCountRunner(),
            new CollapseRunner(),
            new MXRunner(),
            new NormalWinRunner(),
            new BigWinRunner(),
            new MaxWinRunner(),
            new MayhemSpinsRunner(),
            new FeatureIntroRunner(),
            new FeatureOutroRunner()
        ];
    }

    public start(flowStateController: FlowStateController): void {
        this._flowStateController = flowStateController;

        // #230
        Game.monsterReelsView.toggleMask(false);

        SimplePresentationRunner.run(this._presentations, () => this.complete(), (callback?: Function) => flowStateController.setSkipCallback(callback));
    }

    private complete(): void {
        // #497, very ugly hack as a safe check to minimize the impact area
        if (!Game.mxSymbol) {
            const firstReelSymbols: Symbol[] = Game.reelsView.reelModels[0].symbols;
            const lastReelSymbols: Symbol[] = Game.reelsView.reelModels[Game.ACTIVE_REELS_NUM - 1].symbols;

            if (firstReelSymbols.length < 2) {
                for (let i: number = (2 - firstReelSymbols.length); i < 2; i++) {
                    const tempSymbol: Symbol = new Symbol("CR", SymbolStates.NORMAL, i);
                    tempSymbol.position.set(0, (i * Game.SYMBOL_HEIGHT));
                    firstReelSymbols.push(tempSymbol);
                }
            }
            if (lastReelSymbols.length < 2) {
                for (let i: number = (2 - lastReelSymbols.length); i < 2; i++) {
                    const tempSymbol: Symbol = new Symbol("CR", SymbolStates.NORMAL, i);
                    tempSymbol.position.set(((Game.ACTIVE_REELS_NUM - 1) * Game.SYMBOL_WIDTH), (i * Game.SYMBOL_HEIGHT));
                    lastReelSymbols.push(tempSymbol);
                }
            }
            const sym1: Symbol = firstReelSymbols[0];
            if (sym1 && sym1.name !== "CR") {
                if (sym1.name === "P4" && !sym1.parent) {
                    sym1.updateTexture("CR");
                    sym1.isRemoved = false;
                } else {
                    const tempSymbol: Symbol = new Symbol("CR", SymbolStates.NORMAL, 0);
                    tempSymbol.position.set(0);
                    firstReelSymbols.unshift(tempSymbol);
                }
            }
            const sym2: Symbol = firstReelSymbols[firstReelSymbols.length - 1];
            if (sym2 && sym2.name !== "CR") {
                if (sym2.name === "P4" && !sym2.parent) {
                    sym2.updateTexture("CR");
                    sym2.isRemoved = false;
                } else {
                    const tempSymbol: Symbol = new Symbol("CR", SymbolStates.NORMAL, firstReelSymbols.length - 1);
                    tempSymbol.position.set(0, ((firstReelSymbols.length - 1) * Game.SYMBOL_HEIGHT));
                    firstReelSymbols.push(tempSymbol);
                }
            }
            const sym3: Symbol = lastReelSymbols[0];
            if (sym3 && sym3.name !== "CR") {
                if (sym3.name === "P4" && !sym3.parent) {
                    sym3.updateTexture("CR");
                    sym3.isRemoved = false;
                } else {
                    const tempSymbol: Symbol = new Symbol("CR", SymbolStates.NORMAL, 0);
                    tempSymbol.position.set(((Game.ACTIVE_REELS_NUM - 1) * Game.SYMBOL_WIDTH), 0);
                    lastReelSymbols.unshift(tempSymbol);
                }
            }
            const sym4: Symbol = lastReelSymbols[lastReelSymbols.length - 1];
            if (sym4 && sym4.name !== "CR") {
                if (sym4.name === "P4" && !sym4.parent) {
                    sym4.updateTexture("CR");
                    sym4.isRemoved = false;
                } else {
                    const tempSymbol: Symbol = new Symbol("CR", SymbolStates.NORMAL, lastReelSymbols.length - 1);
                    tempSymbol.position.set(((Game.ACTIVE_REELS_NUM - 1) * Game.SYMBOL_WIDTH), ((lastReelSymbols.length - 1) * Game.SYMBOL_HEIGHT));
                    lastReelSymbols.push(tempSymbol);
                }
            }

            for (let i: number = 1; i < firstReelSymbols.length - 1; i++) {
                if (firstReelSymbols[i].name === "CR") {
                    firstReelSymbols[i].updateTexture("P4");
                    firstReelSymbols[i].isRemoved = true;
                }
            }
            for (let i: number = 1; i < lastReelSymbols.length - 1; i++) {
                if (lastReelSymbols[i].name === "CR") {
                    lastReelSymbols[i].updateTexture("P4");
                    lastReelSymbols[i].isRemoved = true;
                }
            }
        }

        this._flowStateController.finish();
    }
}